import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import axios from 'axios'
import './assets/css/base.css'
Vue.config.productionTip = false
Vue.prototype.$axios = axios
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
// import { Tabs, TabPane,BackTop } from 'view-design';
// import Design from 'view-design';
let options = {
  fullscreenEl: false
};
Vue.use(preview, options)
Vue.use(preview)
Vue.use(ElementUI);
Vue.use(ViewUI);
// Vue.component('Tabs', Tabs);
// Vue.component('TabPane', TabPane);
import VueShortkey from 'vue-shortkey'
Vue.use(VueShortkey)
// Vue.component('BackTop', BackTop);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
